import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { authAPI } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];

        if (!sessionId) {
          toast.error("Authentication failed - no session ID");
          navigate("/");
          return;
        }

        // Exchange session_id for user session
        const response = await authAPI.createSession(sessionId);
        const userData = response.data.user;

        login(userData);

        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);

        toast.success(`Welcome, ${userData.name}!`);

        // Redirect based on user type
        if (!userData.user_type) {
          navigate("/select-type", { state: { user: userData } });
        } else if (userData.user_type === "partner") {
          navigate("/partner", { state: { user: userData } });
        } else {
          navigate("/dashboard", { state: { user: userData } });
        }
      } catch {
        toast.error("Authentication failed. Please try again.");
        navigate("/");
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <Loader2 className="w-12 h-12 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground">Signing you in...</p>
    </div>
  );
}
